module.exports = __webpack_public_path__ + "img/bg-bvic3.e4c7bf00.png";